<template>
    <v-menu
      lazy
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      full-width
      :nudge-bottom="-24"
      max-width="290px"
    >
      <v-text-field
        slot="activator"
        :label="label"
        :clearable="clearable"
        v-model="formattedDate"
        :rules="rules"
        append-icon="today"
        readonly
      ></v-text-field>
      <v-date-picker v-model="date" @input="updateFormattedDate" />
    </v-menu>
  </template>
  
  <script>
  import moment from 'moment';
  
  export default {
    props: {
      'label': {},
      'value': {},
      'rules': {},
      clearable: {
        type: Boolean,
        default: false
      }
    },
    name: "choose-date",
    data() {
      return {
        date: this.value,
        formattedDate: this.formatDate(this.value)
      }
    },
    methods: {
      formatDate(date) {
        if (date) {
          return moment(date).format("DD-MM-YYYY");
        }
        return null;
      },
      updateFormattedDate(value) {
        this.formattedDate = this.formatDate(value);
        this.$emit('input', value);
      }
    },
    watch: {
      value(val) {
        this.date = val;
        this.formattedDate = this.formatDate(val);
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .v-picker {
    ::v-deep .v-btn--outline {
      color: red !important;
    }
    ::v-deep .v-btn--active {
      color: red !important;
    }
  }
  </style>
  